import React, { Component } from "react";
import ReactCSSTransitionReplace from "react-css-transition-replace";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { StepHistory } from "components/Steps";
import Logo from "components/Logo";
import Cart from "components/Cart";
import { Type } from "./AdditionalForm";
import { addAdditional, emptyPreviousPreviews } from "./../actions";

import "css/AdditionalPage.css";

class AdditionalPage extends Component {
    constructor(props) {
        super(props);
        this.nextPage = this.nextPage.bind(this);
        this.previousPage = this.previousPage.bind(this);
        this.FormList = [ Type ];
        
        this.state = {
            page: 0
        };
    }

    componentDidMount() {
        this.props.emptyPreviousPreviews();
    }

    nextPage() {
        this.setState({ page: this.state.page + 1 });
    }

    previousPage() {
        this.setState({ page: this.state.page - 1 });
    }

    changePage(newPage) {
        this.setState({ page: newPage });
    }

    handleSubmit(values) {

        this.props.addAdditional(values);

        this.props.history.push("/Summary");
    }

    render() {
        const { page } = this.state;

        let properties = {
            onSubmit: this.nextPage,
            previousPage: this.previousPage,
            setConservatoryType: this.setConservatoryType
        };

        if (page === 0) {
            delete properties.previousPage;
        }

        if (page === this.FormList.length - 1) {
            properties.onSubmit = this.handleSubmit.bind(this);
        } else {
            properties.onSubmit = this.nextPage;
        }

        let Step = this.FormList[page];

        window.dataLayer.push({
            event: "VirtualPageView",
            "VirtualPageURL": this.props.location.pathname + "/" + Step.name
        });

        return (
            <div className="AdditionalPage">
                <Logo topLeft={true} hideTextOnSmall={true} />
                <Cart />
                <StepHistory StepList={this.FormList} StepIndex={page} onStepClick={this.changePage.bind(this)} />
                <ReactCSSTransitionReplace 
                    transitionName={"page"} 
                    transitionEnterTimeout={2000} 
                    transitionLeaveTimeout={1000}
                    className="transition-container">
                    <Step.form key={Step.name} {...properties}/>
                </ReactCSSTransitionReplace>
            </div>
        );
    }
}

export default withRouter(connect(null, {addAdditional, emptyPreviousPreviews})(AdditionalPage));



// WEBPACK FOOTER //
// ./src/containers/AdditionalPage.js